/* eslint-disable prefer-promise-reject-errors */
import { axios } from '@carvana/purchase-utils';

export const fetchOrderOptions = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/order/availableoptions`
  })
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));

export const fetchVerifications = () =>
  axios({
    method: 'get',
    url: `${process.env.API_URL}/api/v1/verification`
  }).then(res => res.data)
  .catch(err => Promise.reject(err?.response));

export const fetchPaymentCollection = async () =>
  axios
    .get(`${process.env.API_URL}/api/v1/paymentcollection/subscription`)
    .then(res => res.data)
    .catch(err => Promise.reject(err?.response));
